export default [
    {
        code: 'ininCatorReport',
        name: '指标报表',
        icon: 'el-icon-s-home',
        parentKey: '',
        selfFlg: 'statement',
        children: [
            {
                code: 'inCode',
                name: '指标查询',
                parentKey: 'ininCatorReport',
                selfFlg: 'target'
            },
            {
                code: 'report',
                name: '报表查询',
                parentKey: 'ininCatorReport',
                selfFlg: 'report'
            }
        ]
    }
];
